export default __webpack_public_path__ + "static/media/hda.ab04ffc1.png";